import React from 'react';
import CustomizedLabel from './CustomizedLable';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Cell, XAxis, YAxis } from 'recharts';


const StanceBeamTripleBarChart = ({ chartData, firstBarColor, secondBarColor, thirdBarColor }) => (
    <ResponsiveContainer width="100%" height={260}>
        <BarChart
            width={900}
            height={260}
            data={chartData}
            margin={{ top: 20, right: 0, left: 0, bottom: 25 }}>
            <XAxis
                dataKey="Text"
                fontFamily="sans-serif"
                tick={{ fontSize: 16 }}
                dy={25}
            />
            <YAxis hide />
            <CartesianGrid
                vertical={false}
                stroke="#ebf3f0"
            />
            <Bar
                dataKey="RespondentPercentage"

                fontFamily="sans-serif"
                label={<CustomizedLabel />}
            >
                {
                    chartData.map((entry, index) => (
                        <Cell fill={chartData[index].color} key={index} />
                    ))
                }
            </Bar>
        </BarChart>
    </ResponsiveContainer>
);

export default StanceBeamTripleBarChart;